import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { MarketPaths } from "Market/Routes/Routing";
import { AddCircle } from "@mui/icons-material";
import { Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router";

const marketCardResource = Resources.base.market.shared.card;

export const MarketCardDefault = () => {
	const { t } = useResource();
	const navigate = useNavigate();
	return (
		<Stack
			spacing={3}
			flexGrow={1}
			height="100%"
			justifyContent="center"
			alignItems="center"
			sx={{ cursor: "pointer" }}
			p={3}
			onClick={() => {
				navigate(MarketPaths.Create.route);
			}}
		>
			<Typography variant="h2">
				{t(marketCardResource.marketHeading)}
			</Typography>
			<Typography variant="body1">
				{t(marketCardResource.marketSubheading)}
			</Typography>
			<AddCircle
				height={50}
				width={50}
				fill={useTheme().palette.primary.main}
			/>
		</Stack>
	);
};
